import React, { useEffect, useState } from 'react';// Import Link icon
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info, Settings, Link, ChevronRight } from 'lucide-react'
import '../shared/AccordianStyle.css';
import { motion, AnimatePresence } from 'framer-motion';
import { CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem } from "@coreui/react";



const PlanSuggestionAccordian = ({ title, content, editAccordion, accordion, deleteAccordion, design = false }) => {
    const [isOpen, setIsOpen] = useState(false);


    useEffect(() => {
        if (title == null) {
            setIsOpen(true)
        }
    }, [])


    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    const accordionBorder = title == null ? 'none' : '1px solid color-mix(in srgb, var(--ui-dashboard-border-strong, #4a4a4a) 84%, var(--ui-text-primary, #f4f4f5) 16%)';

    return (
        <div className="accordion-item w-full accordion-scope " style={{ minWidth: design ? '' : '500px', borderRadius: '10px', border: accordionBorder, marginTop: `${title ? '10px' : '0px'} ` } }  >
            {title && <h2 className="accordion-header " style={{ borderRadius: '10px' }}>
                <button
                    className={`accordion-button ${!isOpen ? 'collapsed' : ''} d-flex justify-content-between align-items-center `}
                    type="button"
                    onClick={toggleAccordion}
                    style={{ borderRadius: '10px' }}
                >
                    {title}

                    <div>
                        <span className="custom-icon ms-auto d-flex gap-1 align-items-center justify-content-center">
                            <ChevronRight size={25} strokeWidth={1.5} onClick={toggleAccordion} style={{ transform: `${isOpen ? "rotate(270deg)" : "rotate(90deg)"}`, transition: "transform 0.3s ease-in-out" }} />
                            <Trash2 size={20} strokeWidth={1.5} onClick={() => deleteAccordion(accordion.id)} />
                            <Pencil size={16} className="me-2" onClick={() => editAccordion(accordion.id, accordion.title)} />
                        </span>
                    </div>

                </button>
            </h2>}
            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        className=" "
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: 'easeInOut' }}
                    >
                        <div className='px-3 py-1'>
                            {content}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default PlanSuggestionAccordian;
